import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DocumentSnapshot } from 'firebase/firestore';
import { LibraryItem } from '../types/library';
import { RootState } from './store';

interface FollowingState {
  posts: LibraryItem[];
  hasMorePosts: boolean;
  lastVisiblePost: DocumentSnapshot<any> | null;
}

const initialState: FollowingState = {
  posts: [],
  hasMorePosts: true,
  lastVisiblePost: null,
};

const followingSlice = createSlice({
  name: 'following',
  initialState,
  reducers: {
    setFollowingPosts: (state, action: PayloadAction<LibraryItem[]>) => {
      state.posts = action.payload;
    },
    addFollowingPosts: (state, action: PayloadAction<LibraryItem[]>) => {
      state.posts = [...state.posts, ...action.payload];
    },
    setHasMoreFollowingPosts: (state, action: PayloadAction<boolean>) => {
      state.hasMorePosts = action.payload;
    },
    setLastVisiblePost: (state, action: PayloadAction<DocumentSnapshot<any> | null>) => {
      state.lastVisiblePost = action.payload;
    },
  },
});

export const {
  setFollowingPosts,
  addFollowingPosts,
  setHasMoreFollowingPosts,
  setLastVisiblePost,
} = followingSlice.actions;

export const selectFollowingPosts = (state: RootState) => state.following.posts;
export const selectHasMoreFollowingPosts = (state: RootState) => state.following.hasMorePosts;
export const selectLastVisiblePost = (state: RootState) => state.following.lastVisiblePost;

export default followingSlice.reducer;
